/**
 * Frecuencias de pago y generación de fechas de vencimiento de un plan.
 */
import { addDays, addMonths, dayOfMonth } from '../calendar/iso-date.js';
import { nextBusinessDay } from '../calendar/guatemala.js';
import { keyedEnum } from '../catalogs/enum.js';
/**
 * Con qué frecuencia paga el cliente. El comercio rural suele pagar semanal o
 * cada 14 días (catorcenal); asalariados y negocios formales, mensual; los
 * créditos agrícolas (café, cardamomo, granos básicos), trimestral alrededor
 * de las cosechas.
 */
export const PAYMENT_FREQUENCIES = ['weekly', 'biweekly', 'monthly', 'quarterly'];
/** Catálogo con clave de frecuencias: `PAYMENT_FREQUENCY.monthly`. */
export const PAYMENT_FREQUENCY = keyedEnum(PAYMENT_FREQUENCIES);
/** Etiquetas en español de cada frecuencia. */
export const PAYMENT_FREQUENCY_LABELS = {
    weekly: 'Semanal',
    biweekly: 'Catorcenal',
    monthly: 'Mensual',
    quarterly: 'Trimestral',
};
/** Períodos de pago en un año, para convertir la tasa anual en tasa del período. */
export const PERIODS_PER_YEAR = {
    weekly: 52,
    biweekly: 26,
    monthly: 12,
    quarterly: 4,
};
/** Duración aproximada de un período en días, usada en cálculos a prorrata. */
export const DAYS_PER_PERIOD = {
    weekly: 7,
    biweekly: 14,
    monthly: 30,
    quarterly: 91,
};
/** Meses de calendario en un trimestre. */
const MONTHS_PER_QUARTER = 3;
/** Vencimiento nominal (sin mover a día hábil) del período `offset` posterior al primero. */
export function nominalDueDate(firstDueDate, frequency, offset) {
    switch (frequency) {
        case 'weekly':
            return addDays(firstDueDate, offset * DAYS_PER_PERIOD.weekly);
        case 'biweekly':
            return addDays(firstDueDate, offset * DAYS_PER_PERIOD.biweekly);
        case 'monthly':
            return addMonths(firstDueDate, offset, dayOfMonth(firstDueDate));
        case 'quarterly':
            return addMonths(firstDueDate, offset * MONTHS_PER_QUARTER, dayOfMonth(firstDueDate));
    }
}
/** Todas las fechas de vencimiento de un plan, en orden. */
export function buildDueDates(options) {
    return Array.from({ length: options.periods }, (_, offset) => {
        const nominal = nominalDueDate(options.firstDueDate, options.frequency, offset);
        return options.shiftToBusinessDay ? nextBusinessDay(nominal, options.calendar) : nominal;
    });
}
//# sourceMappingURL=frequency.js.map